import { EventEmitter } from 'eventemitter3'

class DrawingStateClass {
	constructor() {
		this.emitter = new EventEmitter()
		this.drawTrendline = false
	}

	trendlineEnabled() {
		return this.drawTrendline
	}

	toggleTrendline() {
		this.drawTrendline = !this.drawTrendline
		if (this.drawTrendline) {
			this.emitter.emit('trendline', 'on')
		} else {
			this.emitter.emit('trendline', 'off')
		}
	}

	on(evt, fun) {
    this.emitter.on(evt, fun)
  }

  removeListener(evt) {
    this.emitter.removeListener(evt)
  }
}

var DrawingState = new DrawingStateClass()

export { DrawingState }



// WEBPACK FOOTER //
// ./src/stores/DrawingState.js